export const FOCUSABLE_ELEMENTS_SELECTOR = 'a[href], :enabled:not([type="hidden"]), [tabindex="0"]'

export default function getFocusTrapEventHandler(wrapper) {
  return {
    focusFirst: () => {
      const focusable = Array.from(wrapper.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR))
      focusable[0].focus()
    },
    onFocus: e => {
      const focusable = Array.from(wrapper.querySelectorAll(FOCUSABLE_ELEMENTS_SELECTOR))
      const first = focusable[0]
      const last = focusable[focusable.length - 1]

      if (e.key === 'Tab') {
        // keep focus within the menu
        // it's enough to intercept focus change from the first and last elements
        // and let the browser handle focus changes between other focusable elements in the dialog
        if (!e.shiftKey && e.target === last) {
          first.focus()
          e.preventDefault()
        } else if (e.shiftKey && e.target === first) {
          last.focus()
          e.preventDefault()
        }
      }
    }
  }
}
